// Mock listings data matching screenshot
export const mockListings = [
  {
    id: 1,
    year: 2021,
    make: "Toyota",
    model: "Camry",
    trim: "SE",
    price: 16200,
    mileage: 65300,
    sellerType: "Dealer",
    location: "Hayward, CA",
    distanceMi: 22,
    domDays: 8,
    score: 97,
    profitPotential: 12100,
    tags: ["Best Fit"],
    market: {
      avgPrice: 16600,
      avgDom: 11,
      fastestBandLow: 15200,
      fastestBandHigh: 16800
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 2,
    year: 2020,
    make: "Toyota",
    model: "Camry",
    trim: "LE",
    price: 15800,
    mileage: 62100,
    sellerType: "Dealer",
    location: "Oakland, CA",
    distanceMi: 15,
    domDays: 5,
    score: 88,
    profitPotential: 18000,
    tags: ["Fast Mover"],
    market: {
      avgPrice: 16200,
      avgDom: 14,
      fastestBandLow: 15000,
      fastestBandHigh: 16500
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 3,
    year: 2019,
    make: "Toyota",
    model: "Camry",
    trim: "SE",
    price: 15500,
    mileage: 71500,
    sellerType: "Private",
    location: "San Jose, CA",
    distanceMi: 30,
    domDays: 12,
    score: 82,
    profitPotential: 16000,
    tags: ["Caution"],
    market: {
      avgPrice: 15800,
      avgDom: 18,
      fastestBandLow: 14800,
      fastestBandHigh: 16200
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 4,
    year: 2022,
    make: "Toyota",
    model: "Camry",
    trim: "SE",
    price: 18500,
    mileage: 56500,
    sellerType: "Dealer",
    location: "Union City, CA",
    distanceMi: 18,
    domDays: 3,
    score: 78,
    profitPotential: 17000,
    tags: ["Caution"],
    market: {
      avgPrice: 18200,
      avgDom: 9,
      fastestBandLow: 17500,
      fastestBandHigh: 19000
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 5,
    year: 2021,
    make: "Toyota",
    model: "Camry",
    trim: "XLE",
    price: 19200,
    mileage: 58900,
    sellerType: "Dealer",
    location: "Fremont, CA",
    distanceMi: 5,
    domDays: 6,
    score: 85,
    profitPotential: 15000,
    tags: ["Best Fit"],
    market: {
      avgPrice: 19500,
      avgDom: 12,
      fastestBandLow: 18500,
      fastestBandHigh: 20000
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 6,
    year: 2020,
    make: "Toyota",
    model: "Camry",
    trim: "LE",
    price: 14900,
    mileage: 78000,
    sellerType: "Private",
    location: "San Francisco, CA",
    distanceMi: 35,
    domDays: 15,
    score: 75,
    profitPotential: 14000,
    tags: ["Caution"],
    market: {
      avgPrice: 15200,
      avgDom: 20,
      fastestBandLow: 14200,
      fastestBandHigh: 15800
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 7,
    year: 2019,
    make: "Toyota",
    model: "Camry",
    trim: "SE",
    price: 14200,
    mileage: 89000,
    sellerType: "Dealer",
    location: "Berkeley, CA",
    distanceMi: 28,
    domDays: 10,
    score: 80,
    profitPotential: 13000,
    tags: ["Fast Mover"],
    market: {
      avgPrice: 14500,
      avgDom: 16,
      fastestBandLow: 13500,
      fastestBandHigh: 15000
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 8,
    year: 2022,
    make: "Toyota",
    model: "Camry",
    trim: "LE",
    price: 17500,
    mileage: 48000,
    sellerType: "Dealer",
    location: "Pleasanton, CA",
    distanceMi: 12,
    domDays: 4,
    score: 92,
    profitPotential: 19500,
    tags: ["Best Fit"],
    market: {
      avgPrice: 17800,
      avgDom: 8,
      fastestBandLow: 16800,
      fastestBandHigh: 18200
    },
    thumbnailUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  }
];


